import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb; /* borda do card */
  border-radius: 0 0 8px 8px;
  background-color: #ffffff;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px -8px;
`;

export const HeaderInfo = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  padding: 32px;
  background-color: #ffffff;
  border-bottom: solid 4px #f5f5f5;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
`;

export const HeaderInfoLeft = styled.div`
  width: 70%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  .first-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }
  .second-section {
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
    gap: 4rem;
    width: 100%;
  }
`;

export const ContactArea = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-family: "Inter";
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: 0px;
    text-align: left;
    max-width: 200px;
  }
`;

export const TextHeaderInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  h2 {
    font-family: "Inter";
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.375rem;
    letter-spacing: -0.01em;
    text-align: left;
  }
`;

export const VisitouContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  position: relative;
  height: 100%;
`;

export const OfertaAtivaButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #ffffff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  color: #1f2937;
  transition: background 0.2s;
  white-space: nowrap;

  &:hover {
    background: #f9fafb;
  }

  span {
    color: #1f2937;
  }
`;

export const BadgeCount = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: #2d5bff;
  color: #ffffff !important;
  border-radius: 50%;
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
`;

export const EtiquetaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: fit-content;
  height: 100%;

  h2 {
    font-family: Inter;
    color: #333333;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    text-align: left;
  }

  .add {
    display: flex;
    gap: 6px;
    align-items: center;
    padding: 4px 8px;
    border-radius: 8px;
    font-family: Inter;
    color: #2d5bff;
    background: #eaefff;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
  }

  .icons {
    cursor: pointer;
    color: white;
  }

  .row {
    display: flex;
    gap: 8px;

    .arrow {
      display: flex;
      align-items: center;
      cursor: pointer;
    }
  }
`;

export const Etiqueta = styled.p<{ color: string }>`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  color: white;
  background-color: ${({ color }) => color};
  border-radius: 8px;
  padding: 4px 8px;
  width: fit-content;
`;

export const ConfirmContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 24px;
  box-sizing: border-box;
  font-family: Inter;
  gap: 20px;

  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 21px;
    text-align: left;
    color: #646363;
  }

  .buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 12px;
    width: 100%;

    button {
      padding: 8px;
      box-sizing: border-box;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      font-weight: 500;
      height: 40px;
    }

    .primary {
      background-color: #2d5bff;
      color: white;
    }

    .secondary {
      background-color: transparent;
      color: #424248;
      outline: 1px solid #a3a3a6;
    }
  }
`;

export const Tag = styled.div`
  width: 5.5625rem;
  height: 1.8125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ececec;
  padding: 1px 16px 1px 16px;
  border-radius: 8px;
  gap: 10px;
  font-family: "Inter";
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.125rem;
  letter-spacing: 0px;
`;

export const HeaderInfoRight = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: right;
  gap: 1rem;
  p {
    color: #333333;
    font-family: "Inter";
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.125rem;
    letter-spacing: 0px;
    text-align: left;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 8px;
`;

export const TagTemperatura = styled.div`
  width: auto;
  height: 1.8125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1px 16px 1px 16px;
  border-radius: 1rem;
  font-family: "Inter";
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.125rem;
  letter-spacing: 0px;
`;

export const DadosCompContainer = styled.div`
  width: 100%;
  height: 2.8125rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 32px;
  background-color: #ffffff;
  border-bottom: solid 4px #f5f5f5;

  button {
    border: none;
    color: #2d5bff;
    font-family: "Inter";
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.125rem;
    letter-spacing: 0px;
    text-align: left;
    background-color: transparent;
    &:hover {
      cursor: pointer;
      transition: transform 250ms;
      transform: scale(1.02);
      text-shadow: #2d5bff 1px 0px 80px;
    }
  }
`;

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-family: "Inter";
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.375rem;
  letter-spacing: 0px;
  text-align: left;
  color: #828282;
  padding: 8px 8px 12px 8px;

  .row {
    display: flex;
    flex-direction: column;
    width: 25%;
    min-height: 64px;
    padding: 12px 20px;
    box-sizing: border-box;
    position: relative;

    p {
      margin: 0;
    }

    p:first-child {
      color: #6b7280; /* gray-500 */
      font-size: 12px;
      line-height: 16px;
      margin-bottom: 4px;
    }

    p:last-child {
      color: #111827; /* gray-900 */
      font-size: 14px;
      line-height: 20px;
      font-weight: 500;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      word-break: break-word;
    }
  }
  .row:not(:last-child)::after {
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 40px; /* altura uniforme das linhas */
    background: #9ca3af;
    opacity: 0.9;
    border-radius: 1px;
  }
`;

export const FooterLink = styled.button`
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #2d5bff;
  font-family: Inter;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
  border-top: 1px solid #f3f4f6; /* divisória superior do link */

  &:hover {
    cursor: pointer;
    transition: transform 250ms;
    transform: scale(1.02);
    text-shadow: #2d5bff 1px 0px 80px;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 20px 8px 20px;
  color: #4b5563; /* gray-600 */
  font-family: Inter;
  font-size: 16px;
  font-weight: 500;

  svg {
    width: 16px;
    height: 16px;
    color: #6b7280;
  }
`;

export const Img = styled.img`
  &.img-corretor {
    width: 50%;
  }
`;

export const Pressable = styled.button`
  background: transparent !important;
  cursor: pointer;
`;

export const AtualizarLeadButton = styled.button`
  background-color: #2d5bff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 6px 14px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  height: 32px;
  transition: all 0.3s;

  svg {
    flex-shrink: 0;
  }

  &:hover {
    opacity: 0.9;
  }

  &:active {
    transform: scale(0.98);
  }
`;
